import React, { useEffect, useRef, useState } from 'react';
import { Box, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { MenuIcon } from '../../../../Assets/Images/svgs/AddIcon.js';
import { useQueryParameters } from '../../use-query-parameters.js';
import CKEditorRecipients from '../../../Pages/CKEditorComponent/CKEditorSidebar/ckeditor-recipients.js';
import CKEditorAttachments from '../../../Pages/CKEditorComponent/CKEditorSidebar/ckeditor-attachments.js';
import CKEditoruploadcomp from '../../../Pages/CKEditorComponent/CKEditorSidebar/ck-editoruploadcomp.js';
import {
	setsingedFile,
	updateSingedFile
} from '../../../../Store/Redux/file-list-slice.js';
import { mapFields } from '../../../../utils/map-input-fields.js';
import PrimaryButton from '../../Button/primary-button.js';
import { SUVA_GREY, TERTIARY_GREY } from '../../../../Assets/Constants/theme.js';
import { UploadIcon } from '../../../../Assets/Images/svgs/UploadIcon.js';
import { AvatarIcon } from '../../../../Assets/Images/svgs/AvatarIcon.js';
import { AttachIcon } from '../../../../Assets/Images/svgs/AttachIcon.js';
import { getBase64 } from '../../../../utils/get-base64.js';
import { editPdf } from '../../../../utils/edit-pdf.js';
import { getPdfSingFeild } from '../Fields/get-fields.js';
import CKeditorAddComp from '../../../Pages/CKEditorComponent/CKEditorSidebar/ckeditor-add-comp.js';
import { getEditorContent } from '../../../../utils/get-editor-content.js';
import generatePdffromHtml from '../../../../utils/generate-pdffrom-html.js';
import {
	mapInputData,
	mapTemplateData
} from '../../../Pages/CKEditorComponent/CKEditorSidebar/ck-constants.js';
import { scrollstyleCss } from '../../../../Styles/styles.js';
import Loading from '../../LoaderComponent/loader.js';
import customToast from '../../custom-toast.js';
import './mobilesidebar.m.css';

function CkeditorMobilesidebar() {
	const { getParameter } = useQueryParameters();
	const { showToast } = customToast();
	const createmode = getParameter('createmode');
	const parentRef = useRef();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const storedRecipients = useSelector(
		(state) => state.recipients.data.recipientsList
	);

	const { borderAndMargin, stampBase64 } = useSelector(
		(state) => state.ckeditor
	);
	const enableDownload = useSelector((state) => state.ckeditor.enableDownload);
	const { enableOtp, getPicture, getLocation } = useSelector(
		(state) => state.recipients.data
	);

	const { inputValues } = useSelector((state) => state.fileList);
	const { documentID } = useSelector((state) => state.newesign);
	const defaultPdfSign = useSelector((state) => state.fileList.defaultPdfSign);

	const [selectedElement, setSelectedElement] = useState('');
	const {
		attachedfiles,
		selectedFile,
		selPdf,
		singedInputFields,
		signCoordinates
	} = useSelector((state) => state.fileList);

	const [isPdf, setIsPdf] = useState(false);
	const [signinputFields, setSigninputFields] = useState([]);

	const [snackBar, setSnackBar] = useState(false);
	const [snackBarmsg, setSnackBarmsg] = useState('');
	const [boderData, setBoderData] = useState({});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (selPdf.id && createmode === 'false') {
			setSnackBar(true);
			setSnackBarmsg('Loading Please wait');
			setTimeout(() => {
				setSnackBar(false);
				setSnackBarmsg('');
				getPdfSingFeild(createmode, signinputFields);
			}, 2000);
		}
	}, [selPdf]);

	useEffect(() => {
		if (singedInputFields?.length > 0 && createmode === 'false') {
			setTimeout(() => {
				setSigninputFields(singedInputFields);
				getPdfSingFeild(createmode, singedInputFields);
			}, 2200);
		}
	}, [singedInputFields]);

	useEffect(() => {
		// Check for pdf
		if (
			selectedFile
			&& selectedFile?.length > 0
			&& selectedFile[0]?.type === 'pdf'
			&& createmode === 'false'
		) {
			setIsPdf(true);
		} else {
			const isBorder = selectedFile?.templateConfig?.borderData;
			const border
				= isBorder && JSON.parse(selectedFile?.templateConfig?.borderData);
			if (border?.border) {
				setBoderData(border);
			}
		}
	}, [attachedfiles]);

	const handleClick = (val) => {
		if (val === selectedElement) {
			setSelectedElement('');
		} else {
			setSelectedElement(val);
		}
	};

	const handleNext = () => {
		if (isPdf) {
			setIsLoading(true);
			dispatch(setsingedFile(selectedFile));
			handlePdfSign();
		} else {
			const getSignCoordinatesList
				= window.document.querySelectorAll('.template-esign');

			if (getSignCoordinatesList.length > 1) {
				const checkSign = [...getSignCoordinatesList].find(
					(el) => el.dataset.recp
				);
				if (!checkSign) {
					showToast('error', 'Please add atleast one signature');
					return;
				}
			}

			setIsLoading(true);

			const htmlData = mapFields(createmode, false, true, false);
			const templatePayload = [];

			if (htmlData) {
				generateData(htmlData, templatePayload);
			}
		}
	};

	const generateData = (htmlData, templatePayload) => {
		const getSignCoordinates
			= window.document.querySelectorAll('.template-esign');
		const tempDiv = window.document.querySelector('.tempdivel');

		tempDiv.innerHTML = htmlData;
		tempDiv.style.fontSize = '13.4px';

		tempDiv.style.margin = `${borderAndMargin.margin.top}px  ${borderAndMargin.margin.right}px ${borderAndMargin.margin.bottom}px  ${borderAndMargin.margin.left}px`;

		const spansInsideDiv = window.document.querySelectorAll(
			'#preview-container span'
		);
		const ptagInsideDiv = window.document.querySelectorAll(
			'#preview-container p'
		);

		// Loop through each span element and set font size to 10px
		for (const ptag of ptagInsideDiv) {
			ptag.style.fontSize = '13.2px';
		}

		for (const span of spansInsideDiv) {
			span.style.fontSize = '12px';
		}

		const base64CB = (base64) => {
			mapTemplateData({
				base64,
				templatePayload,
				getSignCoordinates,
				tempDiv,
				htmlData,
				setIsLoading,
				navigate,
				dispatch,
				documentID,
				storedRecipients,
				enableDownload,
				getPicture,
				getLocation,
				stampBase64
			});
		};

		generatePdffromHtml(htmlData, base64CB, borderAndMargin.border?.border || 0);
	};

	async function handlePdfSign() {
		const payloadData = {
			documentPdf: '',
			enableOtp,
			enableDownload,
			getPicture,
			getLocation,
			recipientData: []
		};
		mapInputData(
			payloadData,
			defaultPdfSign,
			selectedFile,
			storedRecipients,
			setIsLoading,
			inputValues
		);

		const getEsignValues = defaultPdfSign.enabled
			? storedRecipients.map((item) => item.userData.firstName)
			: inputValues.map((el) => ({
				val: el.inval,
				coord: el.coord,
				pdfId: el.pdfId
			}));

		const updatedselectedFile = [...selectedFile].map((item) => ({
			...item,
			esign: defaultPdfSign.enabled
				? getEsignValues
				: getEsignValues.map((el) => (el.pdfId === item.id ? el : ''))
		}));

		async function updatePdf(filetoedit) {
			const coordinates = defaultPdfSign.enabled ? signCoordinates : false;
			const blob = await editPdf(filetoedit, coordinates);

			const getDataUrl = (base64) => {
				dispatch(updateSingedFile({ id: filetoedit.id, dataUrl: base64 }));
			};

			getBase64(blob, getDataUrl);
		}

		for (const file of updatedselectedFile) {
			await updatePdf(file);
		}

		setTimeout(() => {
			setIsLoading(false);
			navigate(`/templatepreview?esign=${true}&pdf=${true}`);
		}, 400);
	}

	return (
		<Box position={'relative'} ref={parentRef}>
			{isLoading && (
				<Loading open={isLoading} onClose={() => setIsLoading(false)} />
			)}
			{/* <Snackbar
        sx={{ height: '50%' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={isLoading}
        autoHideDuration={6000}
        onClose={() => setIsLoading(!isLoading)}
        message={'Loading'}
      /> */}

			<Snackbar
				sx={{ height: '50%' }}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				open={snackBar}
				autoHideDuration={6000}
				onClose={() => setSnackBar(!snackBar)}
				message={snackBarmsg}
			/>
			<Box
				sx={{
					transition: 'all 0.5s cubic-bezier(0.19, 1, 0.22, 1)',
					height: 'auto',
					maxHeight: 300,
					overflow: 'hidden',
					overflowY: 'hidden',
					position: 'relative',
					...scrollstyleCss
				}}
				width={'100%'}
				p={selectedElement ? 2 : 0}
			>
				{selectedElement === 'menu' && (
					<Box mt={1} sx={{ overflowY: 'hidden' }}>
						<CKeditorAddComp
							editor={{}}
							handleSidebarClick={() => ''}
							borderData={{}}
							marginData={{}}
							documentID={documentID}
						/>
					</Box>
				)}
				{selectedElement === 'avatar' && <CKEditorRecipients />}
				{selectedElement === 'attach' && <CKEditorAttachments />}
				{selectedElement === 'upload' && (
					<>
						<div className='semiBold14'>Export</div>
						<Box mt={0}>
							<CKEditoruploadcomp
								getEditorContent={() =>
									getEditorContent(createmode, false, false)
								}
								marginData={{}}
								borderData={boderData}
							/>
						</Box>
					</>
				)}
			</Box>
			<Box
				display={'flex'}
				py={2}
				pb={1}
				alignItems={'center'}
				flexDirection={'row'}
				justifyContent={'space-between'}
				width={'78%'}
				margin={'auto'}
			>
				<Box onClick={() => handleClick('menu')} className='ckicon-centeralign'>
					<MenuIcon
						width={26}
						height={26}
						color={selectedElement === 'menu' ? TERTIARY_GREY : SUVA_GREY}
					/>
				</Box>
				<Box
					onClick={() => handleClick('avatar')}
					className='ckicon-centeralign'
				>
					<AttachIcon
						width={26}
						height={26}
						color={selectedElement === 'avatar' ? TERTIARY_GREY : SUVA_GREY}
					/>
				</Box>
				<Box
					onClick={() => handleClick('attach')}
					className='ckicon-centeralign'
				>
					<AvatarIcon
						width={26}
						height={26}
						color={selectedElement === 'attach' ? TERTIARY_GREY : SUVA_GREY}
					/>
				</Box>
				<Box
					onClick={() => handleClick('upload')}
					className='ckicon-centeralign'
				>
					<UploadIcon
						width={26}
						height={26}
						color={selectedElement === 'upload' ? TERTIARY_GREY : SUVA_GREY}
					/>
				</Box>
				<div>
					<PrimaryButton
						value={'Next'}
						backgroundColor={'#B7D423'}
						width={'110px'}
						height={'34px'}
						disabled={
							isPdf && !defaultPdfSign.enabled && inputValues.length === 0
						}
						onClick={handleNext}
						btnClass='template-save_btn'
						textcolor={'#21241E'}
						customStyle={{
							border: '1px solid #b7d423',
							fontFamily: 'Gilroy-SemiBold'
						}}
					/>
				</div>
			</Box>
		</Box>
	);
}

export default CkeditorMobilesidebar;
